import { render, staticRenderFns } from "./CardOriginDestiny.vue?vue&type=template&id=671250fc&"
import script from "./CardOriginDestiny.vue?vue&type=script&lang=js&"
export * from "./CardOriginDestiny.vue?vue&type=script&lang=js&"
import style0 from "./CardOriginDestiny.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports